module.exports = __webpack_public_path__ + "487e0d3b11bf0da4fc46e9b13863e635.pdf";